<template>
  <div class="row">
    <div class="col-12">
      <div class="c-sorting">
        <div class="row">
          <div class="col-lg-12 c-sorting__right">
            <h3 class="float-left">{{ $t('customerList') }}</h3>
            <div class="c-sorting__btn">
              <export v-show="filterFormModel.keyword" :filter="filterFormModel"
                      :total-count="itemCount"></export>
            </div>
          </div>
        </div>
      </div>
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount && filterFormModel.keyword">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize && filterFormModel.keyword" class="pull-right"
                          size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize"
                          @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length && filterFormModel.keyword">
      <div class="c-smart-table tile">
        <div class="row c-smart-table__title">
          <div class="col-4">{{ $t('clientInfo') }}</div>
          <div class="col-4">{{ $t('customerInfo') }}</div>
          <div class="col-4">{{ $t('time') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-4">
            <div v-if="item.client">
              <p>
                <b>{{ $t('companyName') }}:&nbsp;</b><span>{{ item.client.companyName }}</span>
              </p>
              <p>
                <b>{{ $t('phone') }}:&nbsp;</b><span>{{ item.client.phone }}</span>
              </p>
              <p>
                <b>{{ $t('email') }}:&nbsp;</b><span>{{ item.client.email }}</span>
              </p>
              <p>
                <b>Domain:&nbsp;</b><span>{{ item.client.domain }}</span>
              </p>
            </div>
            <div v-else>
              <p class="text-secondary small">{{ $t('unknown') }}</p>
            </div>
          </div>
          <div class="col-4">
            <p>
              <b>{{ $t('customerName') }}:&nbsp;</b>
              <span v-if="item.name">{{ item.name }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </p>
            <p>
              <b>{{ $t('customerCode') }}:&nbsp;</b>
              <span v-if="item.code">#{{ item.code }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </p>
            <p>
              <b>{{ $t('phone') }}:&nbsp;</b>
              <span v-if="item.phone">{{ item.phone }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </p>
            <p>
              <b>{{ $t('email') }}:&nbsp;</b>
              <span v-if="item.email">{{ item.email }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </p>
            <p>
              <b>{{ $t('customerDob') }}:&nbsp;</b>
              <span v-if="item.dob">{{ item.dob | moment('DD/MM/YYYY') }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </p>
          </div>
          <div class="col-4">
            <p>
              <b>{{ $t('createTime') }}:&nbsp;</b>
              <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </p>
            <p>
              <b>{{ $t('updateTime') }}:&nbsp;</b>
              <span v-if="item.updateTime">{{ item.updateTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!filterFormModel.keyword">
      <span>{{ $t('enterNumberNote') }}</span>
    </div>
    <div class="col-12 text-center text-danger" v-else-if="!items.length">
      <span>{{ $t('notFoundSearch') }}</span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import List from '../../mixins/List';
import Export from './CustomerExport.vue';

export default {
  props: ['filter'],
  components: {Export},
  mixins: [List],
  data() {
    return {
      service: '/lookup-customer/customer',
      autoLoad: false,
      defaultFilterFormModel: {
        page: 1,
        pageSize: 10,
      }
    }
  },
  methods: {
    load: _.debounce(function () {
      this.filterFormModel.keyword = this.filter.keyword;
      if (this.filterFormModel.keyword) {
        let loader = this.$loading.show();
        this.$service.get(this.service, {
          params: this.filterFormModel
        }).then(response => {
          this.apply(response.data);
        }).catch(error => {
          if (error.response.data.message) {
            this.$swal({
              text: error.response.data.message,
              icon: 'error'
            });
          }
        }).finally(() => {
          loader.hide();
        });
      }
    }, 200, {leading: true, trailing: false}),
  },
  mounted() {
    this.filterFormModel = Object.assign({}, this.filter, this.defaultFilterFormModel);
  },
  i18n: {
    messages: {
      en: {
        phone: 'Phone number',
        notFoundSearch: 'No result found! Change your search condition and try again!',
        enterNumberNote: "Please enter customer phone number!",
        customerLookup: "Look up customers",
        enterNumber: "Enter phone number",
        registrationTime: "Registration time",
        customerList: "List of customers",
        clientInfo: "Client information",
        customerInfo: "Customer information",
        customerName: "Customer name",
        customerCode: "Customer code",
        customerDob: "Date of birth",
      },
      vi: {
        phone: 'Số điện thoại',
        notFoundSearch: 'Không tìm thấy kết quả nào! Hãy thay đổi điều kiện tìm kiếm và thử lại!',
        enterNumberNote: "Xin hãy nhập số điện thoại khách hàng!",
        customerLookup: "Tra cứu khách hàng",
        enterNumber: "Nhập số điện thoại",
        registrationTime: "Thời gian đăng ký",
        customerList: "Danh sách khách hàng",
        clientInfo: "Thông tin client",
        customerInfo: "Thông tin khách hàng",
        customerName: "Tên khách hàng",
        customerCode: "Mã khách hàng",
        customerDob: "Ngày sinh",
      }
    }
  }
}
</script>